export default "__VITE_PUBLIC_ASSET__1fcd7247__"